
import React from "react";
import { Grow, Table, TableHead, TableBody, TableCell, TableRow, Grid, TableContainer, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../style.css";

export default function EquipmentTypeTable(props) {
    const { t } = useTranslation("translation");

    return (
        <Grid container item md={12}>
            <Grid item xs={1} sm={3} md={2}></Grid>
            {/*Empty grid for alignment*/}
            <Grid item xs={10} sm={6} md={4}>
                <div className="masterDataTable">
                    <Table aria-label="simple table">
                        <TableHead sx={{position: "sticky", top: 0}}>
                            <TableRow>
                                <TableCell align="center">{t("Line")} </TableCell>
                                <TableCell align="center">{t("EquipmentTypeCode")} </TableCell>
                                <TableCell align="center">{t("EquipmentTypeName")} </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.equipmentTypeExcel.map((row, index) => (
                                <TableRow style={{ background: row.hasWarning ? "#FF9089" : "aliceblue" }}>
                                    <TableCell className="fontColor" align="center">{index + 2}</TableCell>
                                    <TableCell className="fontColor" align="center">{row.code}</TableCell>
                                    <TableCell className="fontColor" align="center">{row.name}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Grid>
            <Grid container xs={1} sm={3} md={4}>
                {props.warnings.length > 0 && props.equipmentTypeExcel.length > 0 ? (
                    <>
                        <Grid item md={2}></Grid>
                        <Grid item md={8}>
                        <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                            <TableContainer component={Paper} className="warningTable">
                                <Table sx={{ minWidth: 200 }} aria-label="simple table">
                                    <TableHead sx={{position: "sticky", top: 0}}>
                                        <TableRow>
                                            <TableCell align="center">{t("Line")}</TableCell>
                                            <TableCell align="center">{t("Warnings")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {props.warnings.map((row) => (
                                            <TableRow>
                                                <TableCell className="fontColor" align="center">{row.rowNumber}</TableCell>
                                                <TableCell size="small" className="fontColor" align="center">{row.message}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grow>
                        </Grid>
                        <Grid item md={2}></Grid>
                    </>
                ) : null}
            </Grid>{" "}
            {/*Empty grid for alignment*/}
        </Grid>
    );
}
